import React from 'react';
import { useQuery } from '@apollo/client';
import { Button } from '@mui/material';
import { OrgOrgUnitSelectors } from '../../shared/components/inputs/OrgOrgUnitSelectors';
import ApolloError from '../../shared/components/ApolloError';
import PageInstructions from '../../shared/components/PageInstructions';
import { DATA_DOWNLOAD_TYPES } from '../../shared/constants/DataDownloadTypes';
import useDataDownload from '../hooks/useDataDownload';
import GET_ORGS_AND_UNITS_FOR_EVENT_COMMENT_REPORT from '../queries/getOrgsAndUnitForEventCommentReportQuery';

const PAGE_TITLE = 'Data Download';
const PAGE_DESCRIPTION =
  'Use the download button to access all event comments in the Portal. Limit the data to a subsection by using the filters below.';
const ORG_LABEL = 'Organization Name(s)';
const OU_LABEL = 'OU Name(s)';

export const EventCommentDataDownload = () => {
  const { selections, handleSelections, handleDownloadClick, fileDownloadError } = useDataDownload(
    DATA_DOWNLOAD_TYPES.eventComment
  );

  const {
    data: orgsAndUnitsData,
    loading: orgsAndUnitsLoading,
    error: orgsAndUnitsError
  } = useQuery(GET_ORGS_AND_UNITS_FOR_EVENT_COMMENT_REPORT);

  const organizations = orgsAndUnitsData?.orgsAndUnitsForEventCommentReport || [];

  if (orgsAndUnitsError || fileDownloadError) {
    return <ApolloError />;
  }

  return (
    <>
      <section className='page-instructions'>
        <PageInstructions title={PAGE_TITLE} description={PAGE_DESCRIPTION} />
        <Button className='primary-button' onClick={handleDownloadClick}>
          Download Report
        </Button>
      </section>
      <div className='data-download'>
        <section className='page-section'>
          <OrgOrgUnitSelectors
            sectionClassName='option-selector'
            organizations={organizations}
            orgSelectorProps={{
              value: selections.orgIds,
              onChange: handleSelections('orgIds'),
              label: ORG_LABEL
            }}
            orgUnitSelectorProps={{
              value: selections.orgUnitIds,
              onChange: handleSelections('orgUnitIds'),
              label: OU_LABEL
            }}
            loading={orgsAndUnitsLoading}
          />
        </section>
      </div>
    </>
  );
};
